import React, { useContext } from "react";
import { useState, useEffect, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import { Link } from "react-router-dom";
import { Image } from "react-bootstrap";
import logo from "../assets/images/samagra-logo.png";
// import ecoclub from "../assets/images/ecoclub-logo.png";
import ecoclub from "../assets/images/Logo-2.png";
import MenuOpen from "../assets/images/bars.png";
import MOE from "../assets/images/schoolEdu-logo.png";
import { TbLogin2 } from "react-icons/tb";
import { House } from "phosphor-react";
import pmshreelogo from "../assets/images/pmshree-logo.png";
import AdminLoginModel from "./Authentication/AdminLoginModel";
import SchoolLoginModel from "./Authentication/SchoolLoginModel.jsx";
import FacultyLoginModel from "./Authentication/FacultyLoginModel.jsx";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../context";
import { BsInfoCircle } from "react-icons/bs";
import { PiTarget } from "react-icons/pi";
import { MdOutlineLibraryBooks } from "react-icons/md";
import { TbSocial } from "react-icons/tb";
import { PiUsersThreeLight } from "react-icons/pi";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
// import ecoclub from "../assets/images/ecoclub-logo.png";
import { userLoggedOut } from "../redux/auth/authSlice";
import { useLocation } from "react-router-dom";
import { MdMailOutline } from "react-icons/md";
import { IoCallOutline } from "react-icons/io5";

function Header() {
  const [show, setShow] = useState(false);
  const [show2, setShow2] = useState(false);
  const [authCategory, setAuthCategory] = useState(0);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loginRole, setLoginRole] = useState(null);
  const handleClose = () => {
    setIsClick(false);
    setShow(false);
  };
  const handleClose2 = () => setShow2(false);
  const userData = useSelector((state) => state.auth.user);
  const dispatch = useDispatch();
  const location = useLocation();

  const [isClick, setIsClick] = useState(false);
  const [role, setRole] = useState(null);
  const handleShow = () => setShow(true);
  // const handleShow2 = () => setShow2(true);
  const [manu, setMenu] = useState(false);
  const [showHeader, setShowHeader] = useState(false);
  const [showHeader2, setShowHeader2] = useState(false);
  const { setSectionId } = useContext(AppContext);
  const navigate = useNavigate();
  const menuHandle = () => {
    setMenu(!manu);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  const [showLoginDropdown, setShowLoginDropdown] = useState(false);
  const [isLocked, setIsLocked] = useState(false); // New state to persist open state after click
  const dropdownRef = useRef(null);
  const timeoutRef = useRef(null);

  const handleMouseEnter = () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    setShowLoginDropdown(true);
  };

  const handleMouseLeave = () => {
    if (isLocked) return; // Don't auto-close if it was clicked/locked
    timeoutRef.current = setTimeout(() => {
      setShowLoginDropdown(false);
    }, 300);
  };

  const toggleDropdown = (e) => {
    e.stopPropagation();
    const nextState = !showLoginDropdown;
    setShowLoginDropdown(nextState);
    setIsLocked(nextState); // Lock it open if toggled on via click
  };

  const handleKeyDown = (e) => {
    if (e.key === "Escape") {
      setShowLoginDropdown(false);
      setIsLocked(false);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowLoginDropdown(false);
        setIsLocked(false); // Unlock on click outside
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSelectLogin = (selectedRole) => {
    setRole(selectedRole); // Set the role to show the respective login modal
    setIsClick(true);
    setShowLoginDropdown(false); // Close the dropdown when a login option is selected
    setIsLocked(false);
  };

  // Public pages (e.g. the Special Campaign 6 form) can open the school login
  // popup directly: window.dispatchEvent(new Event("openSchoolLogin")).
  useEffect(() => {
    const open = () => handleSelectLogin("school");
    window.addEventListener("openSchoolLogin", open);
    return () => window.removeEventListener("openSchoolLogin", open);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const Logout = async () => {
    try {
      const makeLogout = await fetch(`https://ecoclubs.education.gov.in/api/logout`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
      });
      if (makeLogout.ok) {
        setIsLoggedIn(false); // Update state
        //  toast.success("Logout Successfully");
      }
    } catch (error) {
      toast.error("Logout Failed");
      console.log(error);
    }
    dispatch(userLoggedOut());
  };
  const handleLogout = async () => {
    await Logout();
    setIsLoggedIn(false); // Update state
    navigate("/"); // Redirect to homepage
  };

  // public pages that must survive a direct load / refresh without login
  const PUBLIC_NO_REDIRECT_PATHS = ["/image-gallery", "/ras-gallery"];
  // Swachhata Hi Seva student quiz + certificate verify (QR scans land on
  // /swachhata-hi-seva/verify/<id> with a fresh load).
  // Special Campaign 6 school upload is public too (no login).
  const PUBLIC_NO_REDIRECT_PREFIXES = ["/swachhata-hi-seva", "/special-campaign-6"];

  useEffect(() => {
    // Check if a user is logged in by checking the token
    // const token = localStorage.getItem("token");
    console.log(userData, "userData21");
    if (
      !userData &&
      location.pathname !== "/admin/login" &&
      !PUBLIC_NO_REDIRECT_PATHS.includes(location.pathname) &&
      !PUBLIC_NO_REDIRECT_PREFIXES.some((p) => location.pathname === p || location.pathname.startsWith(`${p}/`))
    ) {
      setIsLoggedIn(false);
      // Redirect to home or other page if the user is not logged in and the current path is not 'admin-login'
      navigate("/");
    } else if (!userData || userData.name === "") {
      setIsLoggedIn(false);
    } else if (userData.role === 1) {
      setIsLoggedIn(true);
      setLoginRole(userData.role);
    } else {
      setIsLoggedIn(true);
      setLoginRole(userData.role);
    }
  }, [userData]);

  const handleHomeButton = () => {
    if (location.pathname === "/") {
      if (loginRole === 2) {
        navigate("/school");
      } else if (loginRole === 3) {
        navigate("/faculty");
      } else if (loginRole === 1) {
        navigate("/Ekpedmaakenaam");
      } else if (loginRole === 4) {
        const stateMap = {
          'andhrapradesh': 'ANDHRA PRADESH',
          'arunachalpradesh': 'ARUNACHAL PRADESH',
          'assam': 'ASSAM',
          'bihar': 'BIHAR',
          'chhattisgarh': 'CHHATTISGARH',
          'goa': 'GOA',
          'gujarat': 'GUJARAT',
          'haryana': 'HARYANA',
          'himachalpradesh': 'HIMACHAL PRADESH',
          'jammu&kashmir': 'JAMMU & KASHMIR',
          'jharkhand': 'JHARKHAND',
          'karnataka': 'KARNATAKA',
          'kerala': 'KERALA',
          'madhyapradesh': 'MADHYA PRADESH',
          'maharashtra': 'MAHARASHTRA',
          'manipur': 'MANIPUR',
          'meghalaya': 'MEGHALAYA',
          'mizoram': 'MIZORAM',
          'nagaland': 'NAGALAND',
          'odisha': 'ODISHA',
          'punjab': 'PUNJAB',
          'rajasthan': 'RAJASTHAN',
          'sikkim': 'SIKKIM',
          'tamilnadu': 'TAMILNADU',
          'telangana': 'TELANGANA',
          'tripura': 'TRIPURA',
          'uttarakhand': 'UTTARAKHAND',
          'uttarpradesh': 'UTTAR PRADESH',
          'westbengal': 'West Bengal',
          'delhi': 'DELHI',
          'andaman&nicobarislands': 'ANDAMAN & NICOBAR ISLANDS',
          'chandigarh': 'CHANDIGARH',
          'damananddiu': 'DADRA & NAGAR HAVELI AND DAMAN & DIU',
          'lakshadweep': 'LAKSHADWEEP',
          'puducherry': 'Puducherry',
          'kvs': 'KENDRIYA VIDYALAYA SANGHATHAN',
          'nvs': 'NAVODAYA VIDYALAYA SAMITI',
          'ladakh': 'LADAKH',
        };
        const username = userData?.username || "";
        const stateKey = username.toUpperCase().startsWith('EC4ML_')
          ? username.split('_')[1].toLowerCase()
          : '';
        const stateValue = stateMap[stateKey] || null;
        navigate("/admin/environment-day-dashboard", { state: { stateValue } });
      } else {
        navigate("/admin/environment-day-dashboard");
      }
    } else {
      navigate("/");
    }
  };

  useEffect(() => {
    // Check if a user is already logged in by checking the token
    const token = localStorage.getItem("token");
    if (token) {
      const decodedToken = jwtDecode(token);
      setIsLoggedIn(true);
      setLoginRole(decodedToken.role);
    }
  }, []);
  const scrollToSection = (sectionId) => {
    setSectionId(sectionId); // Store the section ID in context
    navigate("/"); // Navigate to eco-club
    // Add a timeout to allow the page to load before scrolling
    setTimeout(() => {
      const section = document.getElementById(sectionId);
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    }, 100); // Adjust the timeout as necessary
  };

  return (
    <div className="mainTopDiv">
      {/* <div className="navbars">
        <ul className="contactList d-flex justify-content-arround align-items-center">
          <li>
            <a href="tel:011-29581423">
              <IoCallOutline /> 011-29581423
            </a>
          </li>
          <li>
            <span>
              <MdMailOutline />
              contact[dot]ecoclubs-edu[at]gov[dot]in
            </span>
          </li>
          <li>
            <span>
              <MdMailOutline />
              info[dot]ecoclubs-edu[at]gov[dot]in
            </span>
          </li>
          <li>
            <span>
              <MdMailOutline />
              help[dot]ecoclubs-edu[at]gov[dot]in
            </span>
          </li>
        </ul>
      </div> */}
      <header>
        <div className="row py-1 animate__animated animate__fadeInDown">
          <div className="logo-sec col-6 col-lg-9 text-start d-flex justify-content-between align-items-center">
            <Link to="/" title="" className="logo-eco">
              <Image src={ecoclub} alt="Logo" width="320px" />
            </Link>

            <Link
              to="https://www.education.gov.in/"
              className="logo-moe"
              title=""
              target="_blank"
            >
              <Image src={MOE} alt="Logo" width={348} />
            </Link>
            <Link
              to="https://samagra.education.gov.in/"
              className="logo-dept"
              title=""
              target="_blank"
            >
              <Image src={logo} alt="Logo" width={240} />
            </Link>
            <Link
              to="https://pmshrischools.education.gov.in/"
              className="logo-moe"
              title=""
              target="_blank"
            >
              <Image src={pmshreelogo} alt="Logo" width={158} />
            </Link>
          </div>

          <div className="menu-sec col-6 col-lg-3 openMenu">
            <div className="login-signup-sec">
              {!isLoggedIn ? (
                <>
                  <div 
                    className="login-dropdown-wrapper" 
                    ref={dropdownRef}
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                    onKeyDown={handleKeyDown}
                  >
                    <button
                      title="Login Options"
                      className={`btn-login-signup loginBtnnewhm adminLogin2 ${showLoginDropdown ? 'active' : ''}`}
                      onClick={toggleDropdown}
                      aria-expanded={showLoginDropdown}
                      aria-haspopup="true"
                    >
                      Login
                    </button>
                    <ul className={`hmLoginList adminLogin2 ${showLoginDropdown ? 'show' : ''}`}>
                      <li>
                        <Link onClick={() => handleSelectLogin("school")}>
                          School Login
                        </Link>
                      </li>
                      <li>
                        <Link onClick={() => handleSelectLogin("faculty")}>
                          Faculty Login
                        </Link>
                      </li>
                      <li className="adminLogin2">
                        <Link className="adminLogin2" to="/admin/login">
                          State Admin Login
                        </Link>
                      </li>
                    </ul>
                  </div>

                  {/* <button title="Try for Free" className="button green btn-login-signup loginBtnnewhm" onClick={() => handleSelectLogin("admin")}>
                    Super Admin
                  </button> */}
                </>
              ) : (
                <>
                  <button
                    className="btn btn-primary mb-0"
                    style={{ marginRight: "15px" }}
                    onClick={() => handleHomeButton()}
                  >
                    Home
                  </button>
                  <button className="btn btn-danger" onClick={handleLogout}>
                    Logout
                  </button>
                </>
              )}
            </div>
          </div>
        </div>

        <Link
          className="menu-mobile-button"
          to={undefined}
          onClick={menuHandle}
        >
          <Image src={MenuOpen} alt="Menu" />
        </Link>
        <nav
          className={
            manu
              ? "navbars mobile open animate__animated animate__fadeInUp"
              : "navbars animate__animated animate__fadeInUp"
          }
        >
          <ul className="d-flex justify-content-center pl-5">
            <li>
              <a href="#" onClick={() => scrollToSection("themes")}>
                <span>
                  <House size={30} />
                </span>{" "}
                Themes
              </a>
            </li>
            <li>
              <a href="#" onClick={() => scrollToSection("aboutEcoClubs")}>
                <BsInfoCircle size={22} /> About Eco Clubs For Mission LiFE
              </a>
            </li>
            <li>
              <a href="#" onClick={() => scrollToSection("objectivesGoals")}>
                <PiTarget size={24} /> Objectives & Goals
              </a>
            </li>
            <li>
              <a href="#" onClick={() => scrollToSection("publications")}>
                <MdOutlineLibraryBooks size={20} /> Publications
              </a>
            </li>
            <li>
              <a href="#" onClick={() => scrollToSection("getSocial")}>
                <PiUsersThreeLight size={20} /> Let's Get Social
              </a>
            </li>
            <li>
              <a href="#" onClick={() => scrollToSection("stakeholders")}>
                <TbSocial size={20} />
                Stakeholders involved
              </a>
            </li>
          </ul>
        </nav>
      </header>
      {isClick && (
        <>
          {role === "school" && (
            <SchoolLoginModel handleViewexit={handleClose} />
          )}
          {role === "faculty" && (
            <FacultyLoginModel handleViewexit={handleClose} />
          )}
          {role === "admin" && <AdminLoginModel handleViewexit={handleClose} />}
        </>
      )}
    </div>
  );
}

export default Header;
